module.exports = __webpack_public_path__ + "assets/panels/neo-1-b0c79373885bd055c56357ea49efb244.svg";